import React, { Component } from 'react';
import Page from '../components/Page';

class About extends Component {
    render() {
        return (
            <Page>
                <h2>{this.props.title}</h2>
                <p>
                    Rufflerim is a French indie collective, developing games with efficient designs and strong stories.
                </p>
            </Page>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/About.js